import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

const { TextArea } = Input;
const { Option } = Select;



interface WoodModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        wood_id?: number;
        wood_name?: string;
    } | null;
    isEditMode?: boolean;
}

const WoodModal: React.FC<WoodModalProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    // Handle form submit
    const handleAddwood = async (values: any) => {
        try {
            const dataVal = {
                wood_name: values.wood_name,
                ...(initialValues?.wood_id && { wood_id: initialValues.wood_id }),
            };
            const url = isEditMode
                ? 'edit-wood-type'
                : 'add-wood-type';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'Wood Type updated successfully!' : 'Wood Type created successfully!',
            );
            form.resetFields();

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} Wood Type`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                wood_name: initialValues.wood_name,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);




    return (
        <Modal
            title={isEditMode ? 'Edit Wood Type' : 'Add New Wood Type'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddwood}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="wood_name"
                            className='px-8'
                            label={
                                <span>
                                    Wood Type &nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 50 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Wood Type Name' },
                                { max: 50, message: 'Maximum 50 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={50}
                                placeholder="e.g., Wood Type "

                            />
                        </Form.Item>
                    </Col>
                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Wood Type
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default WoodModal;
